import { useEffect, useState } from "react";
import useUuid from "./uuid-hook";
import { IValidationProps } from "../components/inputs/input/input";

interface IInputValidationHookProps {
    value?: string | number | null;
    validation?: IValidationProps;
}

export interface IInputValitationResponse {
    isValid: boolean,
    messages: string[];
}

function isEmpty(val?: string | number | null): boolean {
    if (val === 0) return false;
    return !val || val.toString().trim() === "";
}

const useInputValidation = ({ value, validation }: IInputValidationHookProps): IInputValitationResponse => {
    const id = useUuid();
    const [isValid, setIsValid] = useState(true);
    const [messages, setMessages] = useState<string[]>([]);

    useEffect(() => {
        let valid = true;
        let errorMessages: string[] = [];
        /* consider custome validator from outside as callback */
        if (validation?.validationCallback !== undefined) {
            const validationResponse = validation.validationCallback();
            valid = validationResponse.isValid;
            errorMessages = validationResponse.messages;
        }
        if (validation?.required && isEmpty(value)) {
            valid = false;
        }
        setIsValid(valid);
        /** 
         * If we want to display error messages under input 
         * - we should set this to true 
         * - if we want to hide error messages under input - we should set this to false and clear the messages
         * */
        if (validation?.showValidationMessage) {
            setMessages(errorMessages);
        } else if (messages.length > 0) {
            /** clear messages if we want to hide them, for example showValidationMessage is set to false, 
             * after it was true and collected messages - we don't want to show them anymore */
            setMessages([]);
        }

        /** update validation group */
        validation?.validationGroup?.update({ id, isValid: valid, messages: errorMessages });
    }, [validation?.validationGroup, validation?.validationGroup?.shouldRevalidate, validation?.required, validation?.validationCallback, value, id])

    useEffect(() => {
        /** cleanup, remove validation state from group on component unmount */
        return () => validation?.validationGroup?.delete(id);
    }, [validation?.validationGroup, id])

    return { isValid, messages };
}

export default useInputValidation;
